
import { Box } from '@mui/material'
import React from 'react'
import aboutus from '../../../assets/video/Aboutus.mp4'
import './style/section4.css'

const Section4 = () => {
    return (
        <Box className="mt-14 " >
            <div className='bg-black py-28'>
                <p className='text-sm text-center text-white font-semibold uppercase'>PRICE POLICY</p>
                <p className='text-2xl text-center text-white font-semibold  my-5'>Popular understanding, <span className='underline'>Stellare Bijoux</span> for everyone!</p>
                <p className='text-sm text-center text-white'>Cardigan helvetica sriracha, portland celiac truffaut woke artisan succulents
                    <br />cred art party slow-carb pinterest. Migas humblebrag chicharrones everyday <br />carry four loko.</p>
            </div>
            <div className='relative'>
                <div className='video-sect'>
                    <video autoPlay
                        loop
                        playsInline
                        muted
                        style={{ width: "100%", height: "100%" }} src={aboutus} type="video/mp4"></video>
                </div>
                <div className='text-sect hidden md:block'>
                    <p className='text-center text-base font-semibold'>Cardigan helvetica sriracha, portland celiac truffaut woke artisan succulents cred art party slow-carb pinterest. 
                        Migas humblebrag chicharrones everyday carry four loko.</p>
                </div>
            </div>
        </Box>
    )
}

export default Section4
